import { computed } from 'vue';

import { FEATURE_FLAG } from '@/constants/feature_flags';
import {
  REPORT_NOTE_ADDED,
  REPORT_OVERLAP_VISIBLE,
  REPORT_SHARED,
} from '@/constants/timeline';
import { useFeatureFlagStore } from '@/stores';

const REPORT_EVENT_TYPES = [
  REPORT_NOTE_ADDED,
  REPORT_OVERLAP_VISIBLE,
  REPORT_SHARED,
];

export default function useReportTimelineEvents() {
  const { hasFeatureFlag } = useFeatureFlagStore();
  const hasReportEventsEnabled = computed(() =>
    hasFeatureFlag(FEATURE_FLAG.TEMP_TIMELINE_ACTIVITY_LISTS),
  );

  function isReportEventAllowed(event: { type: string }) {
    if (hasReportEventsEnabled.value) return true;
    return !REPORT_EVENT_TYPES.includes(event.type);
  }

  return { hasReportEventsEnabled, REPORT_EVENT_TYPES, isReportEventAllowed };
}
